/* eslint-disable semi */
import { createDecorator } from 'vue-class-component';
import * as utils from './utils';
// import Router from "vue-router";
// import DecoratorConfigs from './DecoratorConfigs';

const debug = process.env.NODE_ENV === 'development';

const DECORATOR_NAME = 'BindAsyncRouter';

/**
 * そのコンポーネントに非同期のvue-routerラッパーメソッドをバインドします
 *
 * 現在の実行スレッドから他のスレッドに一度制御を渡すため、timeoutの実行完了を待機するだけのPromiseを返却します。
 * これにより、対処の処理(画面遷移)がPromiseチェーン内で実行された場合に、
 * その処理（画面遷移）が実際に実行されるまで、当該Promiseチェーンは完了しない状態となる。
 *
 * この制御がない場合、当該Promiseチェーンを抜け、Loading状態が解除された後に画面遷移が行われることになる。
 */
export default function BindAsyncRouter (...args) {
  if (utils.isDecoratorCall(args)) {
    createAppDecorator()(...args);
  } else {
    return createAppDecorator(...args);
  }
}

function createAppDecorator (decoratorOptions = {}) {
  // 設定値のマージ
  // decoratorOptions = DecoratorConfigs.marge(DECORATOR_NAME, decoratorOptions);

  // 実装時の整合性チェック
  // if (debug) {
  //   Nothing to do
  // }

  return createDecorator((options, key) => {
    // 実装時の整合性チェック
    if (debug) {
      console.debug(`${DECORATOR_NAME}: @ ${key}`);

      if (key !== 'data') {
        throw new Error(`${DECORATOR_NAME}: can decorate only data().`);
      }
    }

    // オプション値取得
    // Nothing to do

    // created時の処理を追加
    const created = options.created || function () { };
    options.created = utils.injectBefore(created, function () {
      // 実装時の整合性チェック
      if (debug) {
      }

      this.$_sas = this.$_sas || {};
      this.$_sas.$router = {};

      ['push', 'replace', 'go', 'back', 'forward'].forEach(method => {
        this.$_sas.$router[method] = (...args) => {
          this.$router[method](...args);
          return new Promise(resolve => {
            setTimeout(() => {
              resolve();
            }, 10);
          });
        };
      });
    });

    // destroyed時の処理を追加
    const destroyed = options.destroyed || function () { };
    options.destroyed = utils.injectAfter(destroyed, function () {
      if (this.$_sas) {
        if (this.$_sas.$router) {
          delete this.$_sas.$router;
        }
        if (Object.keys(this.$_sas).length === 0) {
          delete this.$_sas;
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/core/decorators/BindAsyncRouter.js